import { render } from "./ClassHeader.vue?vue&type=template&id=1216c830&scoped=true"
import script from "./ClassHeader.vue?vue&type=script&lang=js"
export * from "./ClassHeader.vue?vue&type=script&lang=js"

import "./ClassHeader.vue?vue&type=style&index=0&id=1216c830&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1216c830"]])

export default __exports__